import type {AxiosRequestConfig} from "axios";
import {storeSession} from "@/generated/stores";

export function getRequestConfig (): AxiosRequestConfig {
  return {
    ...storeSession.httpAuthor,
    headers: {
      ...storeSession.httpAuthor?.headers,
      'X-Client-Version': import.meta.env.VITE_APP_VERSION
    }
  };
}